import React, { FC, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Avatar,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { company, sysName, topContennt } from './styles';
import Logout from '@mui/icons-material/Logout';
import { TMS_ADMIN_TOKEN } from '@/utils/constants';
import { useCookieState } from 'ahooks';
import { useAccounterStore } from '@/global-store/accounter-store';

const UserMenu: FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { accounter, setAccounter } = useAccounterStore((store) => [store.accounter]);
  const [, setToken] = useCookieState(TMS_ADMIN_TOKEN);
  const logout = () => {
    setAccounter(null);
    setToken(undefined);
  };
  const handleLogout = () => {
    logout();
    location.replace('/');
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton onClick={handleClick} size='small' sx={{ ml: 2 }}>
        <Avatar sx={{ width: 32, height: 32 }}>{accounter?.userName[0]}</Avatar>
        <Typography variant='body2' sx={company}>
          {accounter?.userName}
        </Typography>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize='small' />
          </ListItemIcon>
          <ListItemText>退出賬號</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export const Header: FC = () => {
  return (
    <Box
      sx={{
        width: 1,
        paddingX: 2,
        paddingY: 1,
        backgroundColor: 'primary.main',
      }}
    >
      <Box sx={topContennt}>
        <Box>
          <Typography variant='h5' sx={sysName}>
            In Time 大後臺
          </Typography>
          {/* <Typography variant='body2' sx={version}>v{Env.release}</Typography> */}
        </Box>
        <UserMenu />
      </Box>
    </Box>
  );
};
